import React, { useState } from 'react'
import { Table } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { useRequest } from 'ahooks'
import dayjs from 'dayjs'
import Button from '@/components/button/button'
import $msg from '@/utils/message'
import { getLsMemberImportRecords } from '../api'
import { getMemberTablePagination, getTableTotal, MEMBER_TABLE_PAGE_SIZE } from '../table-utils'
import { getOperatorName } from '../member-detail/records/record-utils'
import ImportRecordDetail from './import-record-detail'
import RepeatMemberHandler from './repeat-member-handler'

const statusMap: { [key: number]: string } = {
    0: '导入中',
    1: '待处理重复会员',
    2: '导入成功',
}

const ImportRecord: React.FC = () => {
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(MEMBER_TABLE_PAGE_SIZE)
    const [repeatRecordId, setRepeatRecordId] = useState<number | undefined>()
    const [detailRecordId, setDetailRecordId] = useState<number | undefined>()
    const req = useRequest(() => getLsMemberImportRecords({ page, limit: pageSize }), {
        refreshDeps: [page, pageSize],
        onError: e => $msg('error', e.message || '获取导入记录失败'),
    })
    const columns: ColumnsType<any> = [
        {
            title: '开始时间',
            dataIndex: 'create_time',
            width: 170,
            render: value => dayjs(value).format('YYYY-MM-DD HH:mm:ss'),
        },
        { title: '来源', dataIndex: 'ls_shop_name', width: 180, render: value => value || '表格导入' },
        { title: '状态', dataIndex: 'status', width: 140, render: value => statusMap[value] || value },
        { title: '成功导入数', dataIndex: 'members_imported', width: 120, render: value => value || 0 },
        { title: '操作员', dataIndex: 'creator', width: 140, render: getOperatorName },
        {
            title: '操作',
            width: 140,
            render: (_value, record) =>
                record.status === 1 ? (
                    <span className="action" onClick={() => setRepeatRecordId(record.id)}>
                        处理重复会员
                    </span>
                ) : record.status === 2 ? (
                    <span className="action" onClick={() => setDetailRecordId(record.id)}>
                        查看明细
                    </span>
                ) : (
                    '-'
                ),
        },
    ]

    return (
        <>
            <Button types="primary" className="member-import__record-refresh" onClick={req.refresh}>
                刷新
            </Button>
            <div className="table-container member-import__record-table">
                <Table
                    bordered
                    rowKey="id"
                    loading={req.loading}
                    columns={columns}
                    dataSource={req.data?.records || []}
                    pagination={getMemberTablePagination({
                        current: page,
                        pageSize,
                        total: getTableTotal(req.data?.pagination),
                        onChange: setPage,
                        onShowSizeChange: (nextPage, nextSize) => {
                            setPage(nextPage)
                            setPageSize(nextSize)
                        },
                    })}
                />
            </div>
            <RepeatMemberHandler
                visible={!!repeatRecordId}
                recordId={repeatRecordId}
                onCancel={() => setRepeatRecordId(undefined)}
                onSuccess={() => {
                    setRepeatRecordId(undefined)
                    req.refresh()
                }}
            />
            {detailRecordId ? (
                <ImportRecordDetail recordId={detailRecordId} onClose={() => setDetailRecordId(undefined)} />
            ) : null}
        </>
    )
}

export default ImportRecord
